(function () {
  if (window.__simplerBlogAuthorPostsBound) return;
  window.__simplerBlogAuthorPostsBound = true;

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function srcsetFor(url, widths) {
    return widths.map(function (w) { return esc(withWidth(url, w)) + ' ' + w + 'w'; }).join(', ');
  }

  function stripHtml(text) {
    return String(text == null ? '' : text).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function truncateWords(text, limit) {
    var words = stripHtml(text).split(' ').filter(Boolean);
    if (!words.length) return '';
    if (words.length <= limit) return words.join(' ');
    return words.slice(0, limit).join(' ') + '...';
  }

  function mountSlider(slider) {
    if (typeof Swiper === 'undefined') return;

    var el = slider.querySelector('.sbaap-swiper');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    if (el.swiper) el.swiper.destroy(true, true);

    var scrollbarEl = slider.querySelector('.sbaap-scrollbar');
    var slidesMobile = parseNumber(slider.dataset.slidesMobile, 1.2);
    var slidesTablet = parseNumber(slider.dataset.slidesTablet, 1.6);
    var slidesDesktop = parseNumber(slider.dataset.slidesDesktop, 2);
    var gapMobile = parseNumber(slider.dataset.gapMobile, 16);
    var gapTablet = parseNumber(slider.dataset.gapTablet, 20);
    var gapDesktop = parseNumber(slider.dataset.gapDesktop, 24);

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: gapMobile,
      speed: 450,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      scrollbar: scrollbarEl ? { el: scrollbarEl, draggable: true, dragSize: 'auto' } : undefined,
      breakpoints: {
        769: { slidesPerView: slidesTablet, spaceBetween: gapTablet },
        1200: { slidesPerView: slidesDesktop, spaceBetween: gapDesktop },
      },
    });
  }

  function getConfig(slider) {
    var limit = parseInt(slider.getAttribute('data-sbaap-limit'), 10);
    var excerptWords = parseInt(slider.getAttribute('data-sbaap-excerpt-words'), 10);
    return {
      shop: slider.getAttribute('data-sbaap-shop'),
      version: slider.getAttribute('data-sbaap-version') || '2024-10',
      token: slider.getAttribute('data-sbaap-token') || window.SF_API_TOKEN,
      blogHandle: slider.getAttribute('data-sbaap-blog-handle') || '',
      blogTitle: slider.getAttribute('data-sbaap-blog-title') || '',
      authorHandle: (slider.getAttribute('data-sbaap-author-handle') || '').trim().toLowerCase(),
      currentHandle: (slider.getAttribute('data-sbaap-current-handle') || '').trim().toLowerCase(),
      currentId: String(slider.getAttribute('data-sbaap-current-id') || '').trim(),
      currentUrl: slider.getAttribute('data-sbaap-current-url') || '',
      limit: Number.isInteger(limit) && limit > 0 ? limit : 6,
      showExcerpt: slider.getAttribute('data-sbaap-show-excerpt') === 'true',
      excerptWords: Number.isInteger(excerptWords) && excerptWords > 0 ? excerptWords : 30,
      buttonLabel: slider.getAttribute('data-sbaap-button-label') || '',
    };
  }

  var ARTICLES_QUERY =
    'query SbaapArticles($q: String!, $n: Int!, $after: String) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q, after: $after) {' +
    '    edges { node {' +
    '      id title handle onlineStoreUrl' +
    '      excerpt content(truncateAt: 600)' +
    '      image { url altText }' +
    '      authorRef: metafield(namespace: "custom", key: "author") {' +
    '        reference { ... on Metaobject { handle } }' +
    '      }' +
    '    } }' +
    '    pageInfo { hasNextPage endCursor }' +
    '  }' +
    '}';

  function normalizePath(value) {
    if (!value) return '';
    try {
      var path = String(value).indexOf('://') > -1
        ? new URL(value, window.location.origin).pathname
        : String(value);
      return path.replace(/\/+$/, '').toLowerCase();
    } catch (error) {
      return String(value).replace(/\/+$/, '').toLowerCase();
    }
  }

  function articleIdFromGid(gid) {
    if (!gid) return '';
    var match = String(gid).match(/Article\/(\d+)/i);
    return match ? match[1] : '';
  }

  function isCurrentArticle(node, config) {
    if (!node) return false;

    var currentId = config.currentId || '';
    var nodeId = articleIdFromGid(node.id);
    if (currentId && nodeId && currentId === nodeId) return true;

    var currentHandle = (config.currentHandle || '').trim().toLowerCase();
    var nodeHandle = (node.handle || '').trim().toLowerCase();
    if (currentHandle && nodeHandle && currentHandle === nodeHandle) return true;

    var currentPath = normalizePath(config.currentUrl || window.location.pathname);
    var nodePath = normalizePath(node.onlineStoreUrl || ('/blogs/' + config.blogHandle + '/' + node.handle));
    return !!(currentPath && nodePath && currentPath === nodePath);
  }

  function withoutCurrentArticle(nodes, config) {
    return (nodes || []).filter(function (node) {
      return !isCurrentArticle(node, config);
    });
  }

  function sfRequest(config, query, variables) {
    if (window.StorefrontClient && typeof window.StorefrontClient.request === 'function') {
      return window.StorefrontClient.request(query, variables);
    }
    if (!config.shop || !config.token) return Promise.resolve(null);
    var endpoint = 'https://' + config.shop + '/api/' + config.version + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': config.token },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function matchesAuthor(node, config) {
    var ref = node.authorRef && node.authorRef.reference;
    var refHandle = ref && ref.handle ? String(ref.handle).trim().toLowerCase() : '';
    return !!(config.authorHandle && refHandle && refHandle === config.authorHandle);
  }

  function fetchAuthorArticles(config) {
    var q = config.blogTitle ? "blog_title:'" + config.blogTitle.replace(/(['\\])/g, '\\$1') + "'" : '';
    var matched = [];

    function page(after, guard) {
      if (guard > 60) return Promise.resolve(matched);
      return sfRequest(config, ARTICLES_QUERY, { q: q, n: 250, after: after }).then(function (json) {
        var conn = json && json.data && json.data.articles;
        if (!conn) return guard === 0 ? null : matched;
        (conn.edges || []).forEach(function (edge) {
          var node = edge && edge.node;
          if (!node) return;
          if (isCurrentArticle(node, config)) return;
          if (matchesAuthor(node, config)) matched.push(node);
        });
        if (matched.length >= config.limit) return matched;
        var info = conn.pageInfo || {};
        if (info.hasNextPage && info.endCursor) return page(info.endCursor, guard + 1);
        return matched;
      });
    }

    return page(null, 0);
  }

  function slideHTML(node, config) {
    var url = node.onlineStoreUrl || '/blogs/' + config.blogHandle + '/' + node.handle;
    var media = node.image && node.image.url
      ? '<img class="sbaap-card__image" src="' + esc(withWidth(node.image.url, 900)) + '"' +
        ' srcset="' + srcsetFor(node.image.url, [400, 600, 800, 900]) + '"' +
        ' sizes="(min-width: 769px) 50vw, 85vw" loading="lazy" alt="' + esc(node.image.altText || '') + '">'
      : '<div class="sbaap-card__placeholder" aria-hidden="true"></div>';

    var excerpt = config.showExcerpt
      ? '<div class="sbaap-card__excerpt">' + esc(truncateWords(node.excerpt || node.content || '', config.excerptWords)) + '</div>'
      : '';
    var button = config.buttonLabel
      ? '<a href="' + esc(url) + '" class="sbaap-card__button">' + esc(config.buttonLabel) + '</a>'
      : '';

    return (
      '<div class="swiper-slide"><article class="sbaap-card">' +
      '<a href="' + esc(url) + '" class="sbaap-card__media">' + media + '</a>' +
      '<div class="sbaap-card__body">' +
      (node.title ? '<h3 class="sbaap-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h3>' : '') +
      excerpt +
      button +
      '</div></article></div>'
    );
  }

  function removeCurrentSlidesFromDom(slider, config) {
    var currentPath = normalizePath(config.currentUrl || window.location.pathname);
    if (!currentPath) return;

    slider.querySelectorAll('.swiper-slide').forEach(function (slide) {
      var link = slide.querySelector('a[href]');
      if (!link) return;
      if (normalizePath(link.getAttribute('href')) === currentPath) slide.remove();
    });
  }

  function setLoading(slider, container, isLoading) {
    var loader = container ? container.querySelector('[data-sbaap-loading]') : null;
    if (loader) loader.hidden = !isLoading;
    slider.hidden = isLoading;
    if (isLoading) slider.setAttribute('aria-busy', 'true');
    else slider.removeAttribute('aria-busy');
  }

  function hydrate(slider) {
    if (slider.dataset.sbaapHydrated === 'true') return;
    slider.dataset.sbaapHydrated = 'true';

    var config = getConfig(slider);
    var container = slider.closest('.sbaap-container');
    var hasClient = !!(window.StorefrontClient && window.StorefrontClient.request);

    if (!config.authorHandle || (!hasClient && !config.token)) {
      removeCurrentSlidesFromDom(slider, config);
      mountSlider(slider);
      return;
    }

    if (container) container.hidden = false;
    setLoading(slider, container, true);

    fetchAuthorArticles(config)
      .then(function (nodes) {
        setLoading(slider, container, false);

        if (nodes === null) {
          removeCurrentSlidesFromDom(slider, config);
          if (container && !slider.querySelectorAll('.swiper-slide').length) container.hidden = true;
          mountSlider(slider);
          return;
        }

        var wrapper = slider.querySelector('.swiper-wrapper');
        var matched = withoutCurrentArticle(nodes, config).slice(0, config.limit);

        if (!matched.length) {
          removeCurrentSlidesFromDom(slider, config);
          var serverSlides = slider.querySelectorAll('.swiper-slide').length;
          if (serverSlides) mountSlider(slider);
          else if (container) container.hidden = true;
          return;
        }

        if (wrapper) wrapper.innerHTML = matched.map(function (n) { return slideHTML(n, config); }).join('');
        if (container) container.hidden = false;
        mountSlider(slider);
      })
      .catch(function () {
        setLoading(slider, container, false);
        removeCurrentSlidesFromDom(slider, config);
        if (container && !slider.querySelectorAll('.swiper-slide').length) container.hidden = true;
        mountSlider(slider);
      });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-sbaap-slider]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (root) boot(root);
  });
})();
